module.exports = __webpack_public_path__ + "static/media/PLATA.afc86f49.jpg";